import { cloneDeep } from 'lodash'
import moment from 'moment'

export default {
  FormatNumber (valueNumber, max, precision) {
    if (valueNumber !== null && valueNumber !== '') {
      max = (max !== null && max !== '') ? max : 0
      precision = (precision !== null && precision !== '') ? precision : 0

      var tempNumber = valueNumber.toString().replace(',', '.')
      var valorNegativo = parseFloat(tempNumber) < 0
      if (valorNegativo) {
        tempNumber *= -1
      }
      var valorFinal = (parseFloat(tempNumber)).format(Array(max + 1).join('0') + '.' + Array(precision + 1).join('0'))
      valorFinal = this.FormatNumberToShow(valorFinal)
      if (valorNegativo) {
        valorFinal = '-'.concat(valorFinal)
      }
      return valorFinal
    } else {
      return ''
    }
  },
  FormatToShowDecimal (valueNumber) {
    if (valueNumber) {
      if (valueNumber !== null && valueNumber !== '') {
        var value = valueNumber + ''
        if (value.indexOf('.') > -1 || value.indexOf(',') > -1 || this.IsFloat(valueNumber)) {
          var newStringNumber = this.FormataDecimais(valueNumber, 2)
          return newStringNumber
        }
      }
    }
    return valueNumber
  },
  FormatToSaveDecimal (valueNumber) {
    if (valueNumber) {
      if (valueNumber !== null && valueNumber !== '') {
        var value = valueNumber + ''
        value = value.replace(',', '.')
        var newNumber = value * 1
        return newNumber
      }
    }
    return valueNumber
  },
  ValidBrazilianNumber (valueNumber) {
    if (valueNumber && valueNumber !== null) {
      var value = valueNumber + ''
      return (/^\d+(,\d{0,2})?$/).test(value + '')
    }
    return false
  },
  ValidDate (value) {
    if (Array.isArray(value)) return false
    if (typeof value === 'boolean') return false
    if (!isNaN(value)) return false
    if (value) {
      const formats = [moment.ISO_8601, 'YYYY-MM-DD', 'DD-MM-YYYY']
      return moment(value, formats, true).isValid()
    }
    return false
  },
  FormatDate (value) {
    if (value) {
      return moment(value).format('YYYY-MM-DD')
    }
    return null
  },
  FormatDateBrazilian (value) {
    if (value) {
      return moment(value).format('DD-MM-YYYY')
    }
    return null
  },
  ValidAmericanNumber (valueNumber) {
    if (valueNumber && valueNumber !== null) {
      var value = valueNumber + ''
      return (/^\d+(\.\d{0,2})?$/).test(value + '')
    }
    return false
  },
  FormataDecimais (iValor, iDecimais) {
    if (iValor !== '' && iValor !== null) {
      var sValor = String(iValor)
      sValor = sValor.replace('.', ',')
      var iLen = sValor.length - 1
      var iPosPonto = sValor.indexOf(',')
      var iInd = 0
      var iLenDecimais = 0
      if (iPosPonto > 0) {
        iLenDecimais = (iLen - iPosPonto)
        iInd = iLenDecimais
      } else {
        if (iDecimais > 0) {
          sValor = sValor.concat(',')
        }
        iInd = 0
      }
      while (iInd < iDecimais) {
        sValor = sValor.concat('0')
        iInd = iInd + 1
      }
      return sValor
    } else {
      return ''
    }
  },
  FormatSize (bytes, decimals) {
    if (bytes === 0) return bytes.toFixed(decimals || 0) + ' B'

    const result = Math.floor(Math.log(bytes) / Math.log(1024))

    return (bytes / Math.pow(1024, result)).toFixed(decimals || 0) + ' ' + ' KMGTP'.charAt(result) + 'B'
  },
  Left (str, n) {
    var retorno = ''
    if (n <= 0) {
      retorno = ''
    } else if (n > String(str).length) {
      retorno = str
    } else {
      retorno = String(str).substring(0, n)
    }
    return retorno
  },
  Right (str, n) {
    var retorno = ''
    if (n <= 0) {
      retorno = ''
    } else if (n > String(str).length) {
      retorno = str
    } else {
      var iLen = String(str).length
      retorno = String(str).substring(iLen, iLen - n)
    }
    return retorno
  },
  IsInt (n) {
    return Number(n) === n && n % 1 === 0
  },
  IsFloat (n) {
    return Number(n) === n && n % 1 !== 0
  },
  FormatCode: function (code) {
    var value = code.toString()
    var zero = '0'
    var result = ''

    for (var i = value.length; i < 6; i++) {
      result = result + zero
    }
    return result + value
  },
  MinimizedSidebar: function () {
    if (!document.body.classList.contains('sidebar-minimized')) {
      document.body.classList.add('sidebar-minimized')
    }

    document.body.classList.remove('sidebar-mobile-show')
    // window.scrollTo(0, 0)
  },
  ValidateForms: function (forms, data, self, toast) {
    var result = true
    for (var opt in forms) {
      if (forms[opt].hasOwnProperty('required') && forms[opt].required === true) {
        if (forms[opt].value === null || forms[opt].value === '') {
          toast.warning(self.$lang.Common.Alerts.RequiredField)
          // self.$refs.alert.ShowAlert('warning', self.$lang.Common.Alerts.RequiredField)
          forms[opt].state = false // 'invalid'
          // -->
          console.log('Required: ' + opt)
          setTimeout(function (e) {
            forms[opt].state = null
          }, 7000)
          result = false
        }// else forms[opt].state = true
      }
    }
    if (result && data) {
      this.SetValueToSave(forms, data)
    }

    return result
  },
  // ClearDataForms: function (forms, data) {
  //   for (var opt in forms) {
  //     if (forms[opt].hasOwnProperty('defaultArray')) {
  //       forms[opt].value = []
  //     } else {
  //       forms[opt].value = null
  //     }

  //     if (forms[opt].hasOwnProperty('clearOption')) {
  //       if (forms[opt].clearOption) {
  //         forms[opt].options = []
  //       }
  //     }

  //     forms[opt].state = null
  //   }

  //   for (var property in data) {
  //     data[property] = null
  //   }
  // },
  ClearDataForms: function (forms, data) {
    if (!forms || typeof forms !== 'object') return
    if (!data || typeof data !== 'object') return

    for (var opt in forms) {
      const field = forms[opt]
      if (field && typeof field === 'object') {
        if (field.hasOwnProperty('defaultArray')) {
          field.value = []
        } else {
          field.value = null
        }
        if (field.hasOwnProperty('clearOption') && field.clearOption) {
          field.options = []
        }
        field.state = null
      }
    }

    for (var property in data) {
      data[property] = null
    }
  },
  SetValueInForm: function (forms, data, obj) {
    for (var key in data) {
      if (obj[key] !== '00000000-0000-0000-0000-000000000000') {
        if (obj.hasOwnProperty(key)) {
          data[key] = cloneDeep(obj[key])
          if (forms[key] && forms[key].type && forms[key].type.toLowerCase() === 'string' && (this.ValidBrazilianNumber(obj[key]) || this.ValidAmericanNumber(obj[key]))) {
            data[key] = this.FormatToShowDecimal(obj[key])
          } else if (this.ValidDate(obj[key])) {
            data[key] = moment(obj[key]).toDate() // this.FormatDate(obj[key])
          }
        }
        if (forms.hasOwnProperty(key)) {
          forms[key].value = cloneDeep(obj[key])
          if (forms[key] && forms[key].type && forms[key].type.toLowerCase() === 'string' && (this.ValidBrazilianNumber(obj[key]) || this.ValidAmericanNumber(obj[key]))) {
            forms[key].value = this.FormatToShowDecimal(obj[key])
          } else if (this.ValidDate(obj[key])) {
            forms[key].value = moment(obj[key]).toDate() // this.FormatDate(obj[key])
          }
        }
      }
    }
  },
  SetFormDefaultValues: function (form) {
    for (var key in form) {
      if (form[key].defaultValue !== null && form[key].defaultValue !== undefined) {
        form[key].value = form[key].defaultValue
      } else {
        form[key].value = undefined
      }
    }
  },
  SetValueToSave: function (forms, data) {
    for (var key in forms) {
      if (data.hasOwnProperty(key)) {
        if (forms[key].hasOwnProperty('defaultArray')) {
          var options = forms[key].options
          data[key] = []
          for (var i in options) {
            data[key].push(options[i].value)
          }
        } else {
          data[key] = forms[key].value
          if (!forms[key].hasOwnProperty('type') || forms[key].type.toLowerCase() !== 'string') {
            if (this.ValidBrazilianNumber(forms[key].value) || this.ValidAmericanNumber(forms[key].value)) {
              data[key] = this.FormatToSaveDecimal(forms[key].value)
            } else if (forms[key].value === '') {
              data[key] = null
            }
          }
        }
      }
    }
  },
  IsValid: function (obj) {
    var result = false
    if (obj != null && obj !== '' && obj.length > 0) {
      this.result = true
    }
    return result
  },
  removeItemArray: function (array, value) {
    for (var i in array) {
      if (array[i].value === value) {
        array.splice(i, 1)
      }
    }
    return array
  },
  formatMoney (value) {
    if (value === 'N/D') {
      return 'N/D'
    } else {
      const company = JSON.parse(sessionStorage.getItem('company'))
      if (company.localidade === 'escl') {
        let val = parseInt(value)
        return '$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    }
  },
  moneyFormatHtml () {
    const company = JSON.parse(sessionStorage.getItem('company'))

    if (company.localidade === 'escl') {
      return {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        precision: 0,
        allowNegative: false
      }
    } else {
      return {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        allowNegative: false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/Tools.js